export const IGNORE_QUOTES =
  '\u0027\u00ab\u00bb\u2018\u2019\u201a\u201b\u201e\u201f\u2039\u203a\u300c\u300d\u300e\u300f\u301d\u301e\u301f\ufE41\ufE42\ufE43\ufE44\uff02\uff07\uff62\uff63';
